module.exports = __webpack_public_path__ + "img/icon_popular_growth.20a617fe.svg";